import { Section } from 'components/Section';
import Image from 'components/Shared/Image';
import styles from './brandDescription.scss';
import {
  MAIN_IMAGE_DIMENSIONS,
  BRAND_LOGO_IMAGE_DIMENSIONS,
  logoResponsive,
  mainResponsive,
  OwnProps
} from '../../BGH/brandContent/brandDescription';
import { SeoSection } from 'views/ContentPage/components/themes/PP/seo';

export const BrandDescription = ({
  mainImage,
  header,
  description,
  seoBlock,
  brandLogo
}: OwnProps) => {
  return (
    <Section>
      {mainImage && (
        <Image
          wrapperClassName={styles.mainImageWrapper}
          className={styles.mainImage}
          paddingBottom
          {...MAIN_IMAGE_DIMENSIONS}
          {...mainImage}
          responsive={mainResponsive}
        />
      )}
      <div className={styles.brandDescriptionWrapper}>
        {header && (
          <div className={styles.seoContainer}>
            <SeoSection
              header={header}
              description={description}
              extendedDescription={seoBlock?.content}
              usePadding={false}
            />
          </div>
        )}
        <div className={styles.brandLogoWrapper}>
          <Image {...brandLogo} {...BRAND_LOGO_IMAGE_DIMENSIONS} responsive={logoResponsive} />
        </div>
      </div>
    </Section>
  );
};
